module.exports = {"pathContext":{"name":"AdminTag","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMING_SOON"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ENABLED"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-admin-tag.json
// module id = 1203
// module chunks = 231148046025140